import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Table } from 'shared/ui/TableNew'
import { type TaggedContactsRow } from 'entities/Tags/model/TaggedContactsRow'
import { DeleteContactsBulkAction } from 'pages/settings/pages/tags/ui/TagsAction/TagsAction'
import { getTaggedContactsTableActions } from 'pages/settings/pages/tags/ui/TaggedContactsTable/getTaggedContactsTableActions'
import { useTaggedContactsContext } from 'pages/settings/pages/tags/context/taggedContactsContext'
import styles from './styles.module.scss'
import { columns } from './columns'

export const TaggedContactsTable = observer(() => {
  const store = useTaggedContactsContext()
  const { tableStore, initialLoading, isUserCanManageTags, changePaging, items } = store
  const getColumns = useMemo(() => columns(), [tableStore])
  const rows = useMemo(() => {
    return items.map((item) => {
      item.setActionsProps({
        actions: getTaggedContactsTableActions(item, store, isUserCanManageTags),
      })

      item.setAriaLabel('TagsRow')

      return item
    })
  }, [items, isUserCanManageTags])

  const onRowClick = (row: TaggedContactsRow) => {
    store.onShowDetails(row.id)
  }

  return (
    <section className={styles.table}>
      <Table
        ariaLabel={'TagsTable'}
        store={tableStore}
        columns={getColumns}
        rows={rows}
        loading={initialLoading}
        onRowClick={onRowClick}
        onChangePagination={changePaging}
        withCheckbox={isUserCanManageTags}
        emptyStateProps={{
          text: 'No contacts tagged',
          noIcon: true,
        }}
        headerLeftContentProps={{
          actionsContent: <DeleteContactsBulkAction />,
        }}
      />
    </section>
  )
})
